/**
 * StepButton: action button inside step card (static or dynamic label).
 * Single Responsibility: render button; label from getDynamicLabel(stats) or static label.
 */

import React from 'react';
import PropTypes from 'prop-types';

const BUTTON_BASE_CLASS =
  'content-stretch flex h-[37px] items-center justify-center px-[16px] py-[18px] relative rounded-[10px] shrink-0 min-w-[113px]';
const BUTTON_ENABLED_CLASS = 'bg-[#61b8e7]';
const BUTTON_DISABLED_CLASS = 'bg-[#d9d9d9]';
const LABEL_CLASS =
  'font-[\'Roboto:Bold\',sans-serif] font-bold leading-[normal] relative shrink-0 text-[14px] text-center text-white px-2';
const LABEL_STYLE = { fontVariationSettings: "'wdth' 100" };

function getButtonClassName(isEnabled) {
  return `${BUTTON_BASE_CLASS} ${isEnabled ? BUTTON_ENABLED_CLASS : BUTTON_DISABLED_CLASS}`;
}

const StepButton = ({
  label = '',
  isEnabled = false,
  stats = {},
  getDynamicLabel,
}) => {
  const buttonLabel = getDynamicLabel ? getDynamicLabel(stats) : label;

  return (
    <div
      className={getButtonClassName(isEnabled)}
      data-name="Step action button"
    >
      <p className={LABEL_CLASS} style={LABEL_STYLE}>
        {buttonLabel}
      </p>
    </div>
  );
};

StepButton.propTypes = {
  label: PropTypes.string,
  isEnabled: PropTypes.bool,
  stats: PropTypes.object,
  getDynamicLabel: PropTypes.func,
};

export default StepButton;
